import { Component, input } from '@angular/core';
import { BookOpen } from "../book-open/book-open";
import { CalendarDays } from "../calendar-days/calendar-days";
import { ChevronDown } from "../chevron-down/chevron-down";
import { Close } from "../close/close";
import { Edit } from "../edit/edit";
import { Play } from "../play/play";
import { Search } from "../search/search";
import { Sparkles } from "../sparkles/sparkles";
import { Trash } from "../trash/trash";
import { ArrowLeft } from "../arrow-left/arrow-left";
import { Info } from "../info/info";
import { AlertTriangle } from "../alert-triangle/alert-triangle";
import { Check } from "../check/check";
import { Spinner } from "../spinner/spinner";
import { Whatsapp } from "../whatsapp/whatsapp";
import { Menu } from "../menu/menu";
import { Home } from "../home/home";
import { Plus } from "../plus/plus";
import { Clock } from "../clock/clock";
import { User } from "../user/user";

@Component({
  selector: 'app-switch-icons',
  imports: [
    BookOpen, CalendarDays, ChevronDown, Close, Edit, Play, Search, Sparkles, Trash,
    ArrowLeft, Info, AlertTriangle, Check, Spinner, Whatsapp, Menu, Home,
    Plus, Clock, User,
  ],
  templateUrl: './switch-icons.html',
  styleUrl: './switch-icons.css',
})
export class SwitchIcons {
 icon = input.required<string>()
 size = input<string>('18')
}
